export default {
	mounted() {
		this.resizeObserver = new ResizeObserver(() => {
			this.sendHeightToParent();
		});

		this.resizeObserver.observe(document.body);
		window.addEventListener("resize", this.sendHeightToParent);
	},
	beforeDestroy() {

		if (this.resizeObserver) {
			this.resizeObserver.disconnect();

			window.removeEventListener("resize", this.sendHeightToParent);
		}
	},
	methods: {
		sendHeightToParent() {
			const datepicker = document.querySelector(".tempus-dominus-widget.show")
			let datepickerheight = 0
			if (datepicker) {
				datepickerheight = 220; // Set the height of the date picker if it's visible
			} else {
				datepickerheight = 0;
			}

			let height = document.documentElement.getElementsByTagName('body')[0].scrollHeight;
			height = height + datepickerheight;
			window.parent.postMessage({iframeHeight: height}, '*');
		}
	}
}


